import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class ItemDropdown extends Component {

  render() {

    const {
      name,
      id,
      form,
      searchFn,
      classification,
      location,
      onPostChange,
      multiple,
      subsidiary,
      item_types,
      is_manual_promotion,
      excluded_items,
      included_items,
      brand,
      alternate_class,
      fields,
      expand_uom,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          id={id}
          formId={form}
          searchFn={searchFn}
          dropdownType='item'
          type='item'
          fields={fields}
          searchParams={{
            subsidiary,
            location,
            classification,
            item_types,
            is_manual_promotion,
            excluded_items,
            included_items,
            brand,
            alternate_class,
            expand_uom,
          }}
          component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
          onPostChange={onPostChange}
          valueField='id'
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ItemDropdown);

